import React, { ReactElement } from 'react';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { EnhancedComponentProps, EnhancedComponentType, WrappedComponentType } from './';

const withText = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithText = (props: EnhancedComponentProps): ReactElement => {
    const t = useTranslate();
    const { sku, ...originalProps } = props;
    const message = t('Sorry, this article could not be loaded due to incorrect data in our systems (sku {sku})',
      { sku });

    return <Component {...originalProps}>{message}</Component>;
  };

  return WithText;
};

export { withText };
